import { ReserveDetailContainerPropertiesTypes } from "@website/widget/reserve-gallery/reserve-gallery.types";
import range from "lodash-es/range";
import { useRouter } from "next/router";
import { useEffect } from "react";

export const useReserveGalleryDetailContainer = ({
  galleryLength,
  templateNumber
}: ReserveDetailContainerPropertiesTypes) => {
  const router = useRouter();

  useEffect(() => {
    document
      .querySelector(`#gallery_image_${router.query.index}`)
      ?.scrollIntoView();
  }, [router.query.index]);
  const containerProperties =
    galleryLength > templateNumber
      ? range(0, galleryLength, templateNumber).map((index) => ({
          index: index,
          rowCount:
            index + templateNumber < galleryLength
              ? templateNumber
              : galleryLength % templateNumber
        }))
      : [{ index: 0, rowCount: galleryLength }];

  return { containerProps: containerProperties };
};
